var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "info-a",
    d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,3.81818182 C7.48130659,3.81818182 3.81818182,7.48130659 3.81818182,12 C3.81818182,16.5186934 7.48130659,20.1818182 12,20.1818182 C16.5186934,20.1818182 20.1818182,16.5186934 20.1818182,12 C20.1818182,7.48130659 16.5186934,3.81818182 12,3.81818182 Z M12,11.0909091 C12.4662144,11.0909091 12.8504611,11.4418547 12.9029748,11.8939808 L12.9090909,12 L12.9090909,15.6363636 C12.9090909,16.1384407 12.502077,16.5454545 12,16.5454545 C11.5337856,16.5454545 11.1495389,16.1945089 11.0970252,15.7423828 L11.0909091,15.6363636 L11.0909091,12 C11.0909091,11.497923 11.497923,11.0909091 12,11.0909091 Z M11.3571757,7.72081202 C11.7121977,7.36578993 12.2878023,7.36578993 12.6428243,7.72081202 C12.9978464,8.0758341 12.9978464,8.65143863 12.6428243,9.00646071 C12.2878023,9.36148279 11.7121977,9.36148279 11.3571757,9.00646071 C11.0021536,8.65143863 11.0021536,8.0758341 11.3571757,7.72081202 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "info-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#info-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#info-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    mask: "url(#info-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.4cbe7b25bb2e458028d7dda7e600ac39.svg";
export { ForwardRef as ReactComponent };